const letterTypes = Object.freeze({
  DETERMINED: 1,
  AWARD: 2,
});

export default letterTypes;
